<div class="ant-modal-title">
  <ng-container *nzStringTemplateOutlet="modalConfig.uiTitle">
    <div [innerHTML]="title | localize"></div>
  </ng-container>
</div>
